// axios
import axios from 'axios'

export const baseURL = 'https://atypikhome.herokuapp.com'
//const baseURL = 'http://localhost:3000'
//export const baseURL = 'https://atypikhomeprod.herokuapp.com/'
const headers = { 'Content-Type': 'application/json'}
export default axios.create({
  baseURL,
  headers
  // You can add your headers here
})
